import { TimeInput as MantineTimeInput, TimeInputProps } from '@mantine/dates';

export type ITimeInputProps = TimeInputProps;

/** @registry Design-layer pass-through over Mantine TimeInput; import this instead of @mantine/dates TimeInput outside src/design. Extend here when TimeInput needs house behavior. */
export const TimeInput = MantineTimeInput;
